// extracted by mini-css-extract-plugin
module.exports = {"paperSection":"styles_paperSection__12QWz"};